export const password = {
  btnContinue: "继续",
  changePassword: "更改密码",
  company: "公司",
  confirmPassword: "确认密码",
  email: "电子邮箱",
  emailNotFundTips: "@:password.forgotPasswordEmailNotExistContent",
  failedToUpdatePassword: "更新密码失败",
  forgotPassword: "忘记密码？",
  forgotPasswordEmailNotExistContent:
    "{email}未找到。请重新输入您的账号电子邮件并重试。",
  mustContainBetweenMinToMaxCharacters: "密码必须包含{min}到{max}个字符",
  newPassword: "新密码",
  newPasswordAndYourOldPasswordAreTheSame: "新密码和旧密码相同",
  noSpaceAreAllowed: "不支持空格",
  oldPassword: "旧密码",
  oldPasswordIsIncorrect: "旧密码错误",
  password: "密码",
  pleaseInputTheNewPassword: "请输入新密码",
  pleaseInputTheNewPasswordAgain: "请再次输入新密码",
  pleaseInputYourPassword: "请输入密码",
  resetPassword: "@:password.setPassword",
  resetPasswordFailedContent: "@:password.setPasswordFailedContent",
  resetPasswordSuccessContent: "您的密码已更新。请登录。",
  savedSuccessfully: "保存成功。",
  sendEmailSuccessTips: "验证码已发送到 {email}",
  sendVerificationCode: "发送验证码",
  setPassword: "设置密码",
  setPasswordFailedContent:
    "设置密码失败。请联系您的VIA WorkX Connect云端管理员。",
  theTwoNewPasswordsAreNotTheSame: "两次密码不一致",
  userNotExist: "用户不存在",
  verificationCode: "验证码",
  verificationCodeIsIncorrectTips: "验证码错误",
  yourPasswordHasBeenUpdatedPleaseSignInAgain: "您的密码已更新。请重新登录。",
};
